import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Country } from 'src/app/modules/acbcr/common/models/country.model';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getAppCountries } from 'src/app/modules/acbcr/common/state/reducers/countries-cities.reducers';
import { RegistruGenealogicTableService } from 'src/app/modules/acbcr/common/services/registru-genealogic-table.service';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';

@Component({
  selector: 'app-registru-genealogic-form-block',
  templateUrl: './registru-genealogic-form-block.component.html',
})
export class RegistruGenealogicFormBlockComponent implements OnInit, OnChanges {
  @ViewChild('popover') popover;
  @Input() animalForm: UntypedFormGroup;
  @Input() disabledFields = {};
  @Output() disableSubmit = new EventEmitter();
  @Output() closeUpdateModal = new EventEmitter();

  reasonModalData = {};
  countries: Country[];
  destroy$: Subject<boolean> = new Subject<boolean>();

  initialSectionValue;
  initialGenSectionValue;
  errorMessage;
  popoverOpened = false;
  sectionChanged = false;
  generalSectionChanged = false;
  fitMessage;

  constructor(
    public registruGenealogicTableService: RegistruGenealogicTableService,
    private helperDataService: HelperDataService,
    private store: Store<ApplicationState>,
  ) {}

  ngOnInit(): void {
    this.store
      .pipe(select(getAppCountries))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: Country[]) => {
        this.countries = response;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.animalForm && this.animalForm.value.id) {
      this.initialSectionValue = this.f.sectiune_reg_ro.value;
      this.initialGenSectionValue = this.f.sectiune_reg_general.value;
    }
  }

  rgGenSectionChanged(event) {
    this.handleSectionUnchange();
    if (this.initialGenSectionValue !== event) {
      this.generalSectionChanged = true;
      this.disableSubmit.emit(true);
    }
  }

  rgSectionChanged(section) {
    this.handleSectionUnchange();

    if (section !== this.initialSectionValue && this.animalForm.value.id) {
      this.checkRgSection(this.animalForm.value.id, section);
    }
  }

  viewAfectedDescendants() {
    if (this.popoverOpened) {
      return;
    }

    this.registruGenealogicTableService.simulateFitDescendants(
      this.f.numarmatricol.value,
       this.generalSectionChanged ? this.f.sectiune_reg_general.value : null, this.sectionChanged ? this.f.sectiune_reg_ro.value : null)
      .subscribe(response => {
        this.fitMessage = response;
        this.popoverOpened = true;
        this.popover.open();
    });
  }

  cancelUpdateDescendants() {
    this.handleSectionUnchange();
    this.animalForm.controls.sectiune_reg_ro.setValue(this.initialSectionValue);
    this.animalForm.controls.sectiune_reg_general.setValue(this.initialGenSectionValue);
  }

  updateDescendants() {
    if (this.sectionChanged) {
      this.initialSectionValue = this.f.sectiune_reg_ro.value;
      this.fitDescendants();
    } else if (this.generalSectionChanged) {
      this.fitDescendants();
      this.initialGenSectionValue = this.f.sectiune_reg_general.value;
      this.generalSectionChanged = false;
    }
  }

  private fitDescendants() {
    this.registruGenealogicTableService.fitDescendants(
      this.f.numarmatricol.value,
      this.generalSectionChanged ? this.f.sectiune_reg_general.value : null, this.sectionChanged ? this.f.sectiune_reg_ro.value : null)
      .subscribe(response => {
        this.handleSectionUnchange();
        this.closeUpdateModal.emit();

        if (!(response.status === 204)) {
          const blob = new Blob([response.body], { type: 'application/octet-stream' });
          this.helperDataService.simulateDownload(blob, this.f.numarmatricol.value + '_descendenti.xls');
        }
    });
  }

  private handleSectionUnchange() {
    this.popoverOpened = false;
    this.sectionChanged = false;
    this.generalSectionChanged = false;
    this.popover?.close();
  }

  private checkRgSection(animalId, section) {
    this.registruGenealogicTableService.checkRgSection(animalId, section)
      .subscribe(() => {
        this.sectionChanged = true;
        this.disableSubmit.emit(true);
      }, error => {
        this.errorMessage = error.error.error;
        this.sectionChanged = false;
        this.disableSubmit.emit(false);
        setTimeout(() => {
          this.animalForm.controls.sectiune_reg_ro.setValue(this.initialSectionValue);
          this.errorMessage = null;
        }, 10000);
      });
  }

  viewReasons(animalId) {
    this.reasonModalData = {'animal_id': animalId};
  }

  get f() { return this.animalForm.controls; }
}
